import axios from 'axios';
import { context, api as apiConfig } from '../config';
import { exponentialBackoff, refreshInterceptor, paramsInterceptor, safeApiErrorInterceptor, timeoutInterceptor, tokenInterceptor } from './axios-interceptors';

/**
 * Sets up common headers used in all the applications requests
 */
var baseInstance = function baseInstance() {
  var version = context().clientVersion;
  var headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (version) {
    headers['X-huggg-app-version'] = version;
  }
  var instance = axios.create({
    timeout: apiConfig.timeout,
    headers: headers
  });
  instance.interceptors.request.use(paramsInterceptor);
  instance.interceptors.response.use(null, timeoutInterceptor);
  instance.interceptors.response.use(null, safeApiErrorInterceptor);
  return instance;
};

/**
 * Basic configuration for Axios to work with huggg API
 *
 * for usage see https://github.com/axios/axios
 *
 * @param {Object<autoAuth|boolean>} options [optional] autoAuth: default true.
 *                                      If true will attempt to inject best-guess
 *                                      auth tokens and refresh them if requests
 *                                      fail
 *
 */
var instance = function instance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$autoAuth = _ref.autoAuth,
    autoAuth = _ref$autoAuth === void 0 ? true : _ref$autoAuth,
    _ref$useBackoff = _ref.useBackoff,
    useBackoff = _ref$useBackoff === void 0 ? true : _ref$useBackoff;
  var myInstance = baseInstance();
  if (autoAuth) {
    myInstance.interceptors.response.use(null, refreshInterceptor(instance));
    myInstance.interceptors.request.use(tokenInterceptor);
  }
  if (useBackoff) {
    myInstance.interceptors.response.use(null, exponentialBackoff(instance));
  }
  return Promise.resolve(myInstance);
};
export { instance as axios };